// extracted by mini-css-extract-plugin
module.exports = {"card":"Payments_card__1kQ9T","cardButton":"Payments_cardButton__3-Ops"};